export const CONTACT_INFO = {
  address: 'Plot No. 29, Phase 2, Paigah Colony, Secunderabad - 500003',
  email: 'info@srgroup.in',
  phone: '+91-9848071487',
  map: 'https://maps.app.goo.gl/ZDzVxx5aVNQDXZyh7',
};
